<template>
  <div class="w-full px-6 py-4">
    <div class="flex space-x-4 mb-4">
      <OFieldGroup class="w-full md:w-1/2" :label="$t('general.durationMinutes')" :info="$t('schedule.durationMinutesInfo')">
        <NumberField v-model="_service.duration" />
      </OFieldGroup>

      <OFieldGroup class="w-full md:w-1/2" :label="$t('general.processing')" :info="$t('components.service.edit.resources.processingInfo')">
        <NumberField v-model="_service.processing" />
      </OFieldGroup>
    </div>

    <div class="flex space-x-4 mb-4">
      <OFieldGroup class="w-full md:w-1/2" :label="$t('general.finishing')" :info="$t('components.service.edit.resources.finishingInfo')">
        <NumberField v-model="_service.finishing" />
      </OFieldGroup>

      <OFieldGroup class="w-full md:w-1/2" :label="$t('components.service.edit.resources.customerTimeMode')" :info="$t('components.service.edit.resources.customerTimeModeInfo')">
        <SelectField v-model="_service.customerTimeMode" :options="serviceCustomerTimeModeOptions" />
      </OFieldGroup>
    </div>

    <label class="block font-medium mt-12" tabindex="0">
      <span>{{ $t('components.service.edit.resources.bufferTimes') }}</span>
    </label>
    <p class="block opacity-80 text-sm mb-6">
      {{ $t('components.service.edit.resources.bufferTimesInfo') }}
    </p>

    <div class="flex space-x-4 mb-6">
      <OFieldGroup class="w-full md:w-1/2" :label="$t('components.service.edit.resources.preService')" :info="$t('components.service.edit.resources.preServiceInfo')">
        <NumberField v-model="_service.bufferTimePre" />
      </OFieldGroup>

      <OFieldGroup class="w-full md:w-1/2" :label="$t('components.service.edit.resources.postService')" :info="$t('components.service.edit.resources.postServiceInfo')">
        <NumberField v-model="_service.bufferTimePost" />
      </OFieldGroup>
    </div>

    <div class="flex space-x-4 mb-4">
      <OFieldGroup class="w-full md:w-1/2" :label="$t('components.service.edit.resources.bufferMode')" :info="$t('components.service.edit.resources.bufferModeInfo')">
        <SelectField v-model="_service.bufferTimeMode" :options="serviceBufferTimeModeOptions" />
      </OFieldGroup>
    </div>
  </div>
</template>

<script setup lang="ts">
import { OFieldGroup } from '@/components/elements'
import { SelectField, NumberField } from '@/components/fields'
import { type Service, ServiceBufferTimeMode, ServiceCustomerTimeMode, ServiceBufferTimeModeLabels, ServiceCustomerTimeModeLabels } from '~/_api/models/service'

// Model bindings
const _service = defineModel<Service>('service')

// Use Nuxt app composables
const { $i18n } = useNuxtApp() as any

const serviceBufferTimeModeOptions = [
  { label: $i18n.t(ServiceBufferTimeModeLabels[ServiceBufferTimeMode.aggregate]), value: ServiceBufferTimeMode.aggregate },
  { label: $i18n.t(ServiceBufferTimeModeLabels[ServiceBufferTimeMode.longest]), value: ServiceBufferTimeMode.longest },
  { label: $i18n.t(ServiceBufferTimeModeLabels[ServiceBufferTimeMode.between]), value: ServiceBufferTimeMode.between },
]

const serviceCustomerTimeModeOptions = [
  { label: $i18n.t(ServiceCustomerTimeModeLabels[ServiceCustomerTimeMode.all]), value: ServiceCustomerTimeMode.all },
  { label: $i18n.t(ServiceCustomerTimeModeLabels[ServiceCustomerTimeMode.duration]), value: ServiceCustomerTimeMode.duration },
  { label: $i18n.t(ServiceCustomerTimeModeLabels[ServiceCustomerTimeMode.durationProcessing]), value: ServiceCustomerTimeMode.durationProcessing },
]
</script>
